module.exports = __webpack_public_path__ + "img/nicoProfile.16eeeeb3.png";